import React from 'react';
import './monitorHeader.css';
import Search from "../../Search/Search";
import { useDispatch, useSelector } from "react-redux";
import { monitorViewAction } from "../../../redux/rootReducer";
import { setLocalStorage } from "../../../helpers/LocalStorage";
import { currentVisitorsSagaAction } from "../../../redux/sagaActions";

const MonitorHeader = () => {
    const dispatch = useDispatch();
    const monitor_view = useSelector(state => state.monitor_view);
    const filterTypesOptions = useSelector(state => state.filterTypesOptions);
    const filterCoachesOptions = useSelector(state => state.filterCoachesOptions);
    const currentEstablishment = useSelector(state => state.currentEstablishment);

    return (
        <>
            <Search/>
            <div className="monitor__refresh"
                onClick={ () => dispatch(currentVisitorsSagaAction({
                    establishment: currentEstablishment,
                    subscription_type: JSON.stringify(filterTypesOptions.filter(el => el.active).map(el => el.id)),
                    subscription_coach: JSON.stringify(filterCoachesOptions.filter(el => el.active).map(el => el.id)),
                    preloader: true
                })) }
            >Обновить</div>
            <div className="monitor__views">
                <i
                    className={ `monitor__view monitor__view--tile ${ monitor_view === 'tile' ? 'monitor__view--active' : '' }` }
                    onClick={ () => {
                        if (monitor_view === 'tile') return;
                        dispatch(monitorViewAction('tile'));
                        setLocalStorage('afp_monitor_view', 'tile').then();
                    } }
                />
                <i
                    className={ `monitor__view monitor__view--table ${ monitor_view === 'table' ? 'monitor__view--active' : '' }` }
                    onClick={ () => {
                        if (monitor_view === 'table') return;
                        dispatch(monitorViewAction('table'));
                        setLocalStorage('afp_monitor_view', 'table').then();
                    } }
                />
            </div>
        </>
    );
};

export default MonitorHeader;